module.exports = __webpack_public_path__ + "static/media/nosotros06M.ec559842.jpg";